import { render, staticRenderFns } from "./SiteCard.vue?vue&type=template&id=32152d68&"
import script from "./SiteCard.vue?vue&type=script&lang=js&"
export * from "./SiteCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports